import React from 'react';
import PropTypes from 'prop-types';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import CriteriumTable from '@hydra/common/criterium/CriteriumTable';
import Criterium from '@hydra/common/criterium/Criterium';
import SafeAnchor from '@hydra/common/components/SafeAnchor';

export const ResourcesMinification = ({ criterium }) => {
  const { numeral } = useI18n();
  const { data } = criterium;

  const tableClassNames = {
    head: ['', 'alignRight'],
    body: ['', 'alignRight']
  };

  const byteFormat = '0.0 ib';
  const unminifiedResources = data.unminifiedResources || [];
  const head = ['URL', 'Reduction size'];
  const body = unminifiedResources.map(unminifiedResource => ([
    <SafeAnchor
      rel='nofollow noopener noreferrer'
      title={unminifiedResource.url} target='_blank' href={unminifiedResource.url}
      key={unminifiedResource.url}
    >
      {unminifiedResource.url}
    </SafeAnchor>,
    <span key='minificationSize'>
      {
        numeral(unminifiedResource.sizeBefore - unminifiedResource.sizeAfter) &&
        numeral(unminifiedResource.sizeBefore - unminifiedResource.sizeAfter).format(byteFormat)
      }
    </span>
  ]));

  const unminifiedBytes = unminifiedResources
    .map(v => v.sizeBefore - v.sizeAfter)
    .reduce((a, b) => a + b, 0);

  const content = unminifiedResources.length === 0
    ? <Translate content='resources_minification_ok' />
    : (
      <>
        <Translate
          content='resources_minification_nok'
          with={{ totalUnminifiedBytes: numeral(unminifiedBytes) && numeral(unminifiedBytes).format(byteFormat) }}
        />
        <CriteriumTable
          classNames={tableClassNames}
          head={head}
          rows={body}
          fixedColumns={[3, 2]}
          thinHead
          striped
          nowrap
        />
      </>
      );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

ResourcesMinification.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.object
  })
};

export default React.memo(ResourcesMinification);
